import { Grid } from "@mui/material";
import { FormikProps } from "formik";
import Flex from "../../../../../../../../../components/Flex";
import StyledButtonV2 from "../../../../../../../../../components/app/StyledButtonV2";
import StyledFormModal from "../../../../../../../../../components/globalModal/StyledModal";
import useDisclosure from "../../../../../../../../../hooks/use-disclosure";
import { Form2Payload } from "../../../../../../scheduling/appointment/encounter/encounter-constant";
import { StyleAddButton } from "../../../../../../scheduling/appointment/encounter/default-forms/form-1/StyledAddButton";
import CbtCheckboxNoteList from "./CbtCheckboxNoteList";
import CbtCheckboxNoteListView from "./CbtCheckboxNoteListView";

export const CBT_INTERVENTIONS = [
  {
    key: "psychoeducationRegardingCbtModel",
    label: "Psychoeducation regarding CBT model",
  },
  {
    key: "identificationOfAutomaticThoughts",
    label: "Identification of automatic thoughts",
  },
  {
    key: "identificationOfCognitiveDistortions",
    label: "Identification of cognitive distortions",
  },
  {
    key: "cognitiveRestructuring",
    label: "Cognitive restructuring/challenging negative beliefs",
  },
  {
    key: "examinationOfEvidence",
    label: "Examination of evidence for and against maladaptive thoughts",
  },
  {
    key: "developmentOfAlternativeBalancedThoughts",
    label: "Development of alternative balanced thoughts",
  },
  { key: "behavioralActivation", label: "Behavioral activation" },
  {
    key: "problemSolvingSkillsTraining",
    label: "Problem-solving skills training",
  },
  { key: "copingSkillsDevelopment", label: "Coping skills development" },
  { key: "stressManagementTechniques", label: "Stress management techniques" },
  {
    key: "relaxationAndGroundingExercises",
    label: "Relaxation and grounding exercises",
  },
  {
    key: "goalSettingAndBehavioralExperiments",
    label: "Goal-setting and behavioral experiments",
  },
  { key: "relapsePreventionPlanning", label: "Relapse prevention planning" },
] as const;

interface CbtInterventionsProvidedProps {
  formik: FormikProps<Form2Payload>;
}

const CbtInterventionsProvided = ({
  formik,
}: CbtInterventionsProvidedProps) => {
  const disclosure = useDisclosure();

  return (
    <Grid size={12}>
      <StyleAddButton
        w="100%"
        centerLabel
        onClick={() => disclosure.open()}
        label="Add Interventions Provided"
      />

      <CbtCheckboxNoteListView formik={formik} items={CBT_INTERVENTIONS} />

      <StyledFormModal
        open={disclosure.opened}
        onClose={() => disclosure.close()}
        dialogTitle="Interventions Provided"
        dialogAction={
          <StyledButtonV2
            label="Close"
            variant="contained"
            onClick={() => disclosure.close()}
            sx={{ width: "105px" }}
          />
        }
        sx={{
          "& .MuiDialog-paper": {
            width: "60vw",
            height: "80vh",
          },
        }}
      >
        <Flex flexDirection="column" gap={1} width="100%" pt={2}>
          <CbtCheckboxNoteList formik={formik} items={CBT_INTERVENTIONS} />
        </Flex>
      </StyledFormModal>
    </Grid>
  );
};

export default CbtInterventionsProvided;
